/**
 * Copyright (c) HashiCorp, Inc.
 */

import { hash } from '@ember/helper';
import { HdsSegmentedGroup } from '@hashicorp/design-system-components/components';

import FilterBarFilter from './filter.gts';
import FilterBarSort from './sort.gts';

import type { TOC } from '@ember/component/template-only';
import type { WithBoundArgs } from '@glint/template';
import type { FilterConfig, ToggleArgs } from '../filter-bar';

export interface FilterBarSortGroupSignature {
  Args: {
    toggle: (toggle: ToggleArgs) => void;
    softToggle: (toggle: ToggleArgs) => void;
    applyFilter: (name: string) => void;
    clearPendingFilter: (...args: unknown[]) => void;
    isChecked?: (
      localConfig: FilterConfig,
      name: string,
      value: unknown,
    ) => boolean;
    onSortChange: (key: string, value: string) => void;
    config: FilterConfig;
    localConfig: FilterConfig;
  };
  Blocks: {
    default: [
      {
        Filter?: WithBoundArgs<
          typeof FilterBarFilter,
          | 'dropdown'
          | 'toggle'
          | 'softToggle'
          | 'applyFilter'
          | 'clearPendingFilter'
          | 'isChecked'
          | 'config'
          | 'localConfig'
        >;
        Sort?: WithBoundArgs<
          typeof FilterBarSort,
          'dropdown' | 'onSortChange' | 'config'
        >;
      },
    ];
  };
  Element: HTMLDivElement;
}

const FilterBarSortGroup: TOC<FilterBarSortGroupSignature> = <template>
  <HdsSegmentedGroup class="cut-filter-bar-sort-group" ...attributes as |Group|>
    {{yield
      (hash
        Filter=(component
          FilterBarFilter
          dropdown=Group.Dropdown
          toggle=@toggle
          softToggle=@softToggle
          applyFilter=@applyFilter
          clearPendingFilter=@clearPendingFilter
          isChecked=@isChecked
          config=@config
          localConfig=@localConfig
        )
        Sort=(component
          FilterBarSort
          dropdown=Group.Dropdown
          onSortChange=@onSortChange
          config=@localConfig
        )
      )
    }}
  </HdsSegmentedGroup>
</template>;

export default FilterBarSortGroup;
